import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { appConfig } from './app/app.config';
import { App } from './app/app';

function hideSplashAfter(minMs: number) {
  const el = document.getElementById('app-splash');
  if (!el) return;

  const start = (window as any).__splashStart ?? performance.now();
  const elapsed = performance.now() - start;
  const remaining = Math.max(0, minMs - elapsed);

  setTimeout(() => {
    el.classList.add('splash--hide');
    const done = () => el.remove();
    el.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 500); // garde-fou
  }, remaining);
}

registerLocaleData(localeFr, 'fr-FR');

bootstrapApplication(App, appConfig)
  .then(() => hideSplashAfter(2000))
  .catch((err) => console.error(err));
